


































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { Subject, Package, StudentInfo } from '../../types/payment';
import SubjectSelection from '@/components/payment/SubjectSelection.vue';
import PackageSelectionRegister from '@/components/payment/PackageSelectionRegister.vue';
import UserInfo from '@/components/payment/UserInfo.vue';
import PhoneConfirmation from '@/components/payment/PhoneConfirmation.vue';
import DatePicker from '@/components/payment/DatePicker.vue';
import ImageUpload from '@/components/payment/ImageUpload.vue';
import firebase from 'firebase/app';
import 'firebase/database';
import 'firebase/storage';
import { sendNotifyWithExtra } from '@/services/lineNotify';

@Component({
  components: {
    SubjectSelection,
    PackageSelectionRegister,
    UserInfo,
    PhoneConfirmation,
    DatePicker,
    ImageUpload,
  },
})
export default class extends Vue {
  step = 1;
  selectedSubject: Subject = Subject.none;
  selectedPackage: Package = Package.none;
  studentInfo?: StudentInfo;
  phoneNumber = '';
  selectedTestDate = new Date(0);
  isProfileSelected = false;
  profile?: File;
  isRecieptSelected = false;
  reciept?: File;
  storageRef?: firebase.storage.Reference;
  databaseRef?: firebase.database.Reference;
  onSubmit = false;
  isOfflineTest = true;

  mounted() {
    this.databaseRef = firebase.database().ref('pr/reserve');
    this.storageRef = firebase.storage().ref('pr/reserve');
  }

  get subjectDisplay(): string {
    switch (this.selectedSubject) {
      case Subject.math:
        return ' : เลข';
      case Subject.physics:
        return ' : ฟิสิกส์';
      case Subject.chem:
        return ' : เคมี';
      case Subject.english:
        return ' : อังกฤษ';
      default:
        return '';
    }
  }

  get selectedSubjectColor(): string {
    switch (this.selectedSubject) {
      case Subject.math:
        return 'orange lighten-2';
      case Subject.physics:
        return 'deep-purple lighten-2';
      case Subject.chem:
        return 'cyan lighten-2';
      case Subject.english:
        return 'grey darken-2';
      default:
        return 'primary';
    }
  }

  get packageDisplay(): string {
    switch (this.selectedPackage) {
      case Package.a:
        return ' : 1,000 บาท ค่าสมัครสอบ';
      case Package.d:
        return ' : ค่าสมัครสอบ(1000 บาท)+ค่าเรียน 5 ครั้ง(4000 บาท)';
      default:
        return '';
    }
  }

  get phoneNumberDisplay(): string {
    if (this.step > 3) {
      return `หมายเลขโทรศัพท์ : ${this.phoneNumber}`;
    } else {
      return 'ยืนยันหมายเลขโทรศัพท์';
    }
  }

  get datePickerDisplay(): string {
    if (this.selectedTestDate.getTime() === 0) {
      return 'จองวันและรอบการสอบ';
    } else {
      return `สอบวัน${this.dayOfWeekName(
        this.selectedTestDate.getDay()
      )}ที่ ${this.selectedTestDate.getDate()} ${this.monthName(
        this.selectedTestDate.getMonth()
      )} เวลา ${this.selectedTestDate.getHours()}:00 ถึง ${this.selectedTestDate.getHours() +
        4}:00`;
    }
  }

  onSubjectSelected(subject: Subject) {
    this.selectedSubject = subject;
    this.step = 2;
  }

  onPackageSelected(selectedPackage: Package) {
    this.selectedPackage = selectedPackage;
    this.step = 3;
  }

  onStudentInfoUpdate(studentInfo: StudentInfo) {
    this.studentInfo = studentInfo;
    this.step = 4;
  }

  onPhoneConfirmationSuccess(phoneNumber: string) {
    this.phoneNumber = phoneNumber;
    this.step = 5;
  }

  onPhoneConfirmationFailure() {
    this.phoneNumber = '';
    this.step = 3;
  }

  onDateSelected(selectedDate: Date) {
    this.selectedTestDate = selectedDate;
    this.step = 6;
  }

  onProfileChange(file: File) {
    this.profile = file;
    this.isProfileSelected = true;
  }

  onRecieptChange(file: File) {
    this.reciept = file;
    this.isRecieptSelected = true;
  }

  cancle() {
    this.selectedSubject = Subject.none;
    this.$router.back();
  }

  dayOfWeekName(dow: number): string {
    const dowArr = [
      'อาทิตย์',
      'จันทร์',
      'อังคาร',
      'พุธ',
      'พฤหัส',
      'ศุกร์',
      'เสาร์',
    ];
    return dowArr[dow];
  }

  monthName(month: number): string {
    const monthName = [
      'มกราคม',
      'กุมภาพันธ์',
      'มีนาคม',
      'เมษายน',
      'พฤษภาคม',
      'มิถุนายน',
      'กรกฎาคน',
      'สิงหาคม',
      'กันยายน',
      'ตุลาคม',
      'พฤศจิกายน',
      'ธันวาคม',
    ];
    return monthName[month];
  }

  getFileExtension(file: File): string {
    if (file.type === 'image/png') {
      return 'png';
    } else if (file.type === 'image/jpeg') {
      return 'jpg';
    } else {
      return '';
    }
  }

  async submit() {
    let packageName = '';
    switch (this.selectedPackage) {
      case Package.a:
        packageName = '1000';
        break;
      case Package.d:
        packageName = '5000';
        break;
    }
    if (this.profile && this.reciept && this.storageRef && this.databaseRef) {
      this.onSubmit = true;
      const today = new Date().valueOf();
      const profileFileName = `${today}.${this.getFileExtension(this.profile)}`;
      const recieptFileName = `${today}.${this.getFileExtension(this.reciept)}`;
      const profile = await this.storageRef
        .child(`profile/${profileFileName}`)
        .put(this.profile);
      const reciept = await this.storageRef
        .child(`reciept/${recieptFileName}`)
        .put(this.reciept);
      const profileUrl = await profile.ref.getDownloadURL();
      const recieptUrl = await reciept.ref.getDownloadURL();
      try {
        await this.databaseRef.update({
          [`${today}`]: {
            subject: this.selectedSubject,
            package: packageName,
            info: this.studentInfo,
            phoneNumber: this.phoneNumber,
            testDate: this.selectedTestDate,
            profileUrl,
            recieptUrl,
          },
        });
        try {
          await sendNotifyWithExtra(
            'MonkeyTopup',
            `\n\uD83C\uDF93 สมัคร นร.ใหม่\nชื่อ: ${
              this.studentInfo?.firstName
            }\nชื่อเล่น: ${this.studentInfo?.nickName}\nชั้น: ${
              this.studentInfo?.grade
            }\nโรงเรียน: ${this.studentInfo?.school}${
              this.selectedSubject !== Subject.none
                ? '\nวิชา: ' + this.selectedSubject
                : ''
            }\nวันสอบ: ${this.selectedTestDate.getDate()}/${this.selectedTestDate.getMonth() +
              1}/${this.selectedTestDate.getFullYear()} ${this.selectedTestDate.getHours()}:00\nPackage: ${packageName}\nเบอร์โทร: ${
              this.phoneNumber
            }\nline ผปค.: ${this.studentInfo?.parentLineId}\nline นร.: ${
              this.studentInfo?.lineId
            }\nคนขาย: ${this.studentInfo?.saleMan}\nคนแนะนำ: ${
              this.studentInfo?.recommendedById
            }`,
            profileUrl
          );
          await sendNotifyWithExtra(
            'MonkeyTopup',
            '\nใบโอนค่าสมัคร',
            recieptUrl
          );
        } catch (error) {
          console.log(error);
        }
        this.$router.push('3');
      } catch (err) {
        console.log(err);
        this.onSubmit = false;
      }
    }
  }
}
